import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import GitCours from './pages/GitCours';
import NodeCours from './pages/NodeCours';
import ReactCours from './pages/react/ReactCours';
import './App.css'
import SqlCours from './pages/SqlCours';
import ExercicesNode from './pages/ExercicesNode';
import ApiRestFull from './pages/ApiRestFull';
import ProgrammationCours from "./pages/ProgrammationCours";
import JsCours from './pages/JsCours';
import HtmlCours from './pages/html/HtmlCours';
import ReactCours2 from './pages/ReactCours2';
import UmlHistObj from './pages/Uml/UmlHistObj';
import UmlDiagram from './pages/UmlDiagram';
import CssCours from './pages/css/CssCours';


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/GitCours" exact element={<GitCours />} />
          <Route path='/NodeCours' exact element={<NodeCours />} />
          <Route path='/ReactCours' exact element={<ReactCours />} />
          <Route path='/SqlCours' exact element={<SqlCours />} />
          <Route path='/ExercicesNode' exact element={<ExercicesNode />} />
          <Route path='/ApiRestFull' exact element={<ApiRestFull />} />
          <Route path='/ProgrammationCours' exact element={<ProgrammationCours />} />
          <Route path='/JsCours' exact element={<JsCours />} />
          <Route path='/HtmlCours' exact element={<HtmlCours />} />
          <Route path='/ReactCours2' exact element={<ReactCours2 />} />
          <Route path='/UmlHistObj' exact element={<UmlHistObj />} />
          <Route path='/UmlDiagram' exact element={<UmlDiagram />} />
          <Route path='/CssCours' exact element={<CssCours />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
